import {
  formatTime,
  tryTransNumber,
  transRegion,
  bakContent,
} from '../../render-helper';

export default [
  {
    header: 'md5_uni',
    render: 'md5_uni',
    renderHelper: [tryTransNumber],
  },

  { header: 'Url', render: 'news_url' },
  {
    header: 'Title_Original',
    render: 'news_title',
  },
  {
    header: 'Title_Chinese',
    render: 'title_cn',
  },
  {
    header: 'Title_English',
    render: 'title_en',
  },
  {
    header: 'Content_Original',
    render: 'content',
  },
  {
    header: 'Content_Chinese',
    render: 'content_cn',
    renderHelper: [bakContent('news_detail_info')],
  },
  {
    header: 'Content_English',
    render: 'content_en',
    renderHelper: [bakContent('news_detail_info')],
  },
  {
    header: 'Engagement',
    render: 'engagement',
    numFmt: '#,##',
  },
  {
    header: 'Reach',
    render: 'visit_number',
    numFmt: '#,##',
  },
  {
    header: 'Published Date',
    render: 'release_time',
    renderHelper: [formatTime('YYYY-MM-DD')],
  },
  {
    header: 'Published Time',
    render: 'release_time',
    renderHelper: [formatTime('YYYY-MM-DD HH:mm:ss')],
  },
  {
    header: 'Language',
    render: 'news_language',
    renderHelper: [transRegion(3)],
  },
  { header: 'Region', render: 'market' },
  { header: 'Source', render: 'source' },
  { header: 'Type of Coverage', render: 'coverage_type' },
  { header: 'Bate', render: 'bate' },
  { header: 'Topic', render: 'topic' },
];
